import { createModalState } from '../utils';

const {
  Provider: InfoModalProvider,
  useModalState: useInfoModalState,
  useModalDispatch: useInfoModalDispatch,
} = createModalState({
  stateContextName: 'InfoModalStateContext',
  dispatchContextName: 'InfoModalDispatchContext',
});

export { InfoModalProvider, useInfoModalState, useInfoModalDispatch };
